// Remembers the action row last opened from a list, so the list can briefly celebrate it once it's completed
export const COMPLETED_FLASH_MS = 1000;

type OpenedAction = { row: any; index: number; completedAt?: number };

let opened: OpenedAction | null = null;
let returning = false;

export const rememberOpenedAction = (row, index: number) => {
    opened = { row, index };
    returning = true;
};

export const returningAction = (): OpenedAction | null => (returning ? opened : null);

export const clearReturningAction = () => {
    returning = false;
};

export const markActionCompleted = (actionId) => {
    if (opened && opened.row.id === actionId) opened.completedAt = Date.now();
};

export const recentlyCompletedAction = (): OpenedAction | null =>
    opened?.completedAt && Date.now() - opened.completedAt < COMPLETED_FLASH_MS ? opened : null;
